import { supabase } from "@/integrations/supabase/client";

/**
 * Recomputes the signed-in member's Civic Score from real events and creates
 * in-app notifications for newly earned badges and improved radar areas.
 * Safe to call often — it only notifies on changes since the last snapshot.
 */
export async function syncCivicProgress(): Promise<number> {
  const { data, error } = await supabase.rpc("sync_civic_progress" as never);
  if (error) return 0;
  return typeof data === "number" ? data : 0;
}
